import { Component, Input, OnInit } from '@angular/core';
import { PolicyModels } from 'models/policy.models';

@Component({
  selector: 'wz-car-viewer',
  templateUrl: './car-viewer.component.html',
  styleUrls: ['./car-viewer.component.scss'],
  standalone: false,
})
export class CarViewerComponent implements OnInit {
  @Input() car!: PolicyModels.VehicleDetails;
  @Input() showTypeMine = true;

  constructor() {}

  ngOnInit() {}
}
